import { AlertCircle, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: prefersReduced ? 'instant' : 'smooth', block: 'start' });
};

export const DidYouKnow = () => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="did-you-know-section"
      className="py-16 lg:py-24 px-6 sm:px-8"
      style={{ backgroundColor: 'var(--vc-bg)' }}
    >
      <div className="max-w-[1160px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          {/* Label */}
          <div className="inline-flex items-center gap-2 mb-6">
            <AlertCircle className="w-4 h-4" style={{ color: 'var(--vc-gold)' }} />
            <span
              className="text-xs font-medium tracking-widest uppercase"
              style={{ color: 'var(--vc-gold)', fontFamily: 'Inter, sans-serif' }}
            >
              {t('didyouknow.label')}
            </span>
          </div>

          {/* Statement */}
          <p
            className="text-xl sm:text-2xl lg:text-[28px] font-semibold leading-snug tracking-tight"
            style={{ fontFamily: 'Inter, sans-serif', color: 'var(--vc-fg)' }}
          >
            {t('didyouknow.statement')}
          </p>

          <p
            className="mt-5 text-base leading-relaxed max-w-xl mx-auto"
            style={{ color: 'var(--vc-fg-muted)', fontFamily: 'Inter, sans-serif' }}
          >
            {t('didyouknow.body')}
          </p>

          {/* Learn More CTA */}
          <button
            data-testid="did-you-know-learn-more"
            onClick={() => scrollToSection('faq')}
            className="mt-8 inline-flex items-center gap-2 h-11 px-6 text-sm font-medium rounded-xl border transition-colors duration-200 active:scale-[0.98]"
            style={{
              color: 'var(--vc-gold)',
              borderColor: 'var(--vc-gold)',
              backgroundColor: 'transparent',
              fontFamily: 'Inter, sans-serif',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(214,168,74,0.12)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            {t('didyouknow.cta')}
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
